let ErrorView = function (props) {
  let message = props.message || "Oh no! Something went wrong.";

  return (
    <div className="mc-error-view">
      <img src="./img/mc/crash.svg" width="100" height="90"/>
      <h1>{message}</h1>
    </div>
  );
};

module.exports = ErrorView;